<template>
  <div class="main-container">
    <UserFeedbackList />
  </div>
</template>

<script>
import UserFeedbackList from "@/components/UserFeedbacks/List/index.vue";
export default {
  name: "client-feedbacks",
  components: {
    UserFeedbackList,
  },
};
</script>